import { render, staticRenderFns } from "./CreateTaxes.vue?vue&type=template&id=dc46ac7c"
import script from "./CreateTaxes.vue?vue&type=script&lang=js"
export * from "./CreateTaxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports